/**
 * INFORME DE EMPRESA - JavaScript
 * Gestión de tabs y funcionalidades interactivas
 */

document.addEventListener('DOMContentLoaded', function() {
  initTabs();
  initProgressBars();
  initFavoritos();
});

/**
 * Inicializa el sistema de tabs
 */
function initTabs() {
  const tabBtns = document.querySelectorAll('.tab-btn');
  const tabContents = document.querySelectorAll('.tab-content');

  const tabsNav = document.querySelector('.informe-tabs');

  tabBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const tabId = btn.dataset.tab;

      // Remove active from all
      tabBtns.forEach(b => b.classList.remove('active'));
      tabContents.forEach(c => c.classList.remove('active'));

      // Add active to clicked
      btn.classList.add('active');
      const targetTab = document.getElementById(tabId);
      if (targetTab) {
        targetTab.classList.add('active');
      }

      // Update URL hash for sharing
      history.replaceState(null, null, `#${tabId}`);

      // Scroll so the active tab content starts right under the sticky
      // tabs nav + global header, so the user doesn't lose context.
      if (tabsNav && targetTab) {
        requestAnimationFrame(() => {
          const tabTop = targetTab.getBoundingClientRect().top + window.scrollY;
          const navHeight = tabsNav.offsetHeight;
          const globalHeader = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
          const targetY = tabTop - globalHeader - navHeight - 8;
          if (window.scrollY > targetY) {
            window.scrollTo({ top: targetY, behavior: 'smooth' });
          }
        });
      }
    });
  });

  // Check URL hash on load
  const hash = window.location.hash.slice(1);
  if (hash) {
    const targetBtn = document.querySelector(`[data-tab="${hash}"]`);
    if (targetBtn) {
      targetBtn.click();
    }
  }
}

/**
 * Anima las barras de progreso del scorecard (legacy y nuevo header)
 */
function initProgressBars() {
  // Legacy progress bars
  const legacyProgressBars = document.querySelectorAll('.progress');

  const legacyObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const bar = entry.target;
        const width = bar.style.width;
        bar.style.width = '0%';
        setTimeout(() => {
          bar.style.width = width;
        }, 100);
        legacyObserver.unobserve(bar);
      }
    });
  }, { threshold: 0.5 });

  legacyProgressBars.forEach(bar => legacyObserver.observe(bar));

  // New informe-header progress bars with staggered animation
  initInformeHeaderProgressBars();
}

/**
 * Anima las barras de progreso del nuevo informe-header
 * con animación escalonada como en latest-reports
 */
function initInformeHeaderProgressBars() {
  // Find progress bars in panel, scorecard grid, or header
  const container = document.querySelector('.informe-panel') || document.getElementById('informe-header');
  if (!container) return;

  const progressBars = container.querySelectorAll('.informe-header__progress-fill, .scorecard-grid .informe-header__progress-fill');
  if (!progressBars.length) return;

  // Initially set all bars to 0 width
  progressBars.forEach(bar => {
    bar.style.width = '0%';
  });

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Animate each bar with staggered timing
        progressBars.forEach((bar, index) => {
          const targetWidth = bar.dataset.width || '0';
          setTimeout(() => {
            bar.style.width = targetWidth + '%';
          }, index * 100); // 100ms delay between each bar
        });
        observer.unobserve(entry.target);
      }
    });
  }, {
    root: null,
    rootMargin: '0px 0px -50px 0px',
    threshold: 0.2
  });

  observer.observe(container);
}

/**
 * Función para cargar datos de API externa (para uso futuro)
 * Ejemplo: cotización en tiempo real
 */
async function fetchStockPrice(ticker) {
  try {
    // Ejemplo con API pública (Alpha Vantage, Yahoo Finance proxy, etc.)
    // const response = await fetch(`https://api.example.com/stock/${ticker}`);
    // const data = await response.json();
    // return data.price;
    console.log('Función de cotización disponible para:', ticker);
    return null;
  } catch (error) {
    console.error('Error fetching stock price:', error);
    return null;
  }
}

/**
 * Verifica si el usuario tiene suscripción activa
 * Integración futura con sistema de membresías
 */
function checkSubscription() {
  // Esto se integrará con el sistema de suscripción de Shopify
  // Por ahora retorna false (contenido bloqueado)
  const customerTags = window.ShopifyAnalytics?.meta?.page?.customerId || null;
  return false;
}

/**
 * Desbloquea contenido premium si el usuario está suscrito
 */
function unlockPremiumContent() {
  if (checkSubscription()) {
    const lockedTabs = document.querySelectorAll('.tab-content.locked');
    lockedTabs.forEach(tab => {
      tab.classList.remove('locked');
      const overlay = tab.querySelector('.locked-overlay');
      if (overlay) {
        overlay.remove();
      }
    });
  }
}

/**
 * =============================================
 * FUNCIONALIDAD DE FAVORITOS
 * =============================================
 */

/**
 * Inicializa todos los botones de favoritos (header + panel CTA)
 */
function initFavoritos() {
  const wrappers = document.querySelectorAll('.favorito-wrapper');
  wrappers.forEach(wrapper => {
    const btn = wrapper.querySelector('.btn-favorito');
    if (btn && !btn._favInitialized) {
      btn._favInitialized = true;
      btn.addEventListener('click', () => toggleFavorito(wrapper));
    }
  });
}

/**
 * Sincroniza todas las instancias del botón de cartera del informe.
 * (Fase 4: el botón de favorito pasa a "Añadir a cartera" / "En cartera ✓".)
 */
function setInformePortfolioState(added) {
  document.querySelectorAll('.favorito-wrapper').forEach(w => {
    w.dataset.inPortfolio = added ? 'true' : 'false';
    const icon = w.querySelector('.favorito-icon');
    const text = w.querySelector('.favorito-text');
    const btn = w.querySelector('.btn-favorito');
    if (icon) icon.textContent = added ? '✓' : '+';
    if (text) text.textContent = added ? (w.dataset.labelAdded || 'En cartera') : (w.dataset.labelAdd || 'Añadir a cartera');
    if (btn) btn.setAttribute('aria-label', added ? 'Ya en tu cartera' : 'Añadir a cartera');
  });
}

/**
 * Click del botón de cartera del informe.
 *  - Anónimo            → /pages/onboarding?from=favorito&add={handle} (se siembra watch).
 *  - Logueado, ya está  → /pages/mi-cartera (no reescribe, no degrada importes).
 *  - Logueado, nuevo    → upsert_position (watch) con snapshot completo (no borra existentes).
 */
async function toggleFavorito(wrapper) {
  if (!wrapper) return;

  const handle = wrapper.dataset.handle || '';
  const isLoggedIn = wrapper.dataset.customerLoggedIn === 'true';

  // 1) Anónimo → onboarding con el ticker precargado.
  if (!isLoggedIn) {
    window.location.href = '/pages/onboarding?from=favorito&add=' + encodeURIComponent(handle);
    return;
  }

  const miCarteraUrl = wrapper.dataset.miCarteraUrl || '/pages/mi-cartera';

  // 2) Ya en cartera → a Mi cartera, sin reescribir.
  if (wrapper.dataset.inPortfolio === 'true') {
    window.location.href = miCarteraUrl;
    return;
  }

  const ticker = wrapper.dataset.ticker || '';
  const productGid = wrapper.dataset.productGid || '';
  const customerId = (window.SR_CUSTOMER_ID || wrapper.dataset.customerId || '').toString().replace(/[^0-9]/g, '');
  const webhooks = window.SR_PORTFOLIO_WEBHOOKS || {};
  const webhook = (webhooks.upsert_position || '').trim();
  let snapshot = Array.isArray(window.SR_PORTFOLIO_SNAPSHOT) ? window.SR_PORTFOLIO_SNAPSHOT.slice() : null;

  // 3) Sin contexto seguro (snapshot/webhook/customer) NO escribimos directo —
  //    un upsert parcial podría borrar la cartera. Caemos al onboarding.
  if (!webhook || !customerId || snapshot === null) {
    window.location.href = '/pages/onboarding?from=favorito&add=' + encodeURIComponent(handle);
    return;
  }

  if (!snapshot.some(p => (p.ticker || '').toUpperCase() === ticker.toUpperCase())) {
    snapshot.push({ ticker: ticker, product_gid: productGid, handle: handle });
  }

  // Optimistic
  setInformePortfolioState(true);
  document.querySelectorAll('.favorito-wrapper .btn-favorito').forEach(b => {
    b.disabled = true;
    b.classList.add('btn-favorito--loading');
  });

  try {
    const response = await fetch(webhook, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        action: 'upsert_position',
        customer_id: customerId,
        ticker: ticker,
        product_gid: productGid,
        transactions: [],
        net_shares: 0,
        avg_price: 0,
        invested: 0,
        mode: 'watch',
        positions: snapshot
      })
    });
    if (!response.ok) throw new Error(`HTTP error: ${response.status}`);
    window.SR_PORTFOLIO_SNAPSHOT = snapshot;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'add_to_portfolio', source: 'informe', ticker: ticker, mode: 'watch' });
  } catch (error) {
    console.error('Error al añadir a la cartera:', error);
    setInformePortfolioState(false);
    showFavoritoError('No se pudo añadir a tu cartera. Inténtalo de nuevo.');
  } finally {
    document.querySelectorAll('.favorito-wrapper .btn-favorito').forEach(b => {
      b.disabled = false;
      b.classList.remove('btn-favorito--loading');
    });
  }
}

/**
 * Muestra un mensaje de error temporal
 */
function showFavoritoError(message) {
  const wrapper = document.querySelector('.favorito-wrapper');
  if (!wrapper) return;

  // Remover error existente si hay
  const existingError = wrapper.querySelector('.favorito-error');
  if (existingError) existingError.remove();

  const errorDiv = document.createElement('div');
  errorDiv.className = 'favorito-error';
  errorDiv.textContent = message;
  wrapper.appendChild(errorDiv);

  // Auto-remover después de 4 segundos
  setTimeout(() => {
    errorDiv.remove();
  }, 4000);
}

/* ===========================================
   INFORME - Buy flow + GA4
   =========================================== */
(function() {
  'use strict';

  var data = window.__informeData;
  if (!data || data.hasAccess) return;

  var ga4Item = {
    item_id: String(data.productId),
    item_name: data.productTitle,
    price: data.productPrice,
    quantity: 1
  };

  function sendGA4Event(eventName, items) {
    if (typeof gtag === 'function') {
      gtag('event', eventName, {
        currency: data.currency,
        value: data.productPrice,
        items: items
      });
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      ecommerce: {
        currency: data.currency,
        value: data.productPrice,
        items: items
      }
    });
  }

  async function buyInforme() {
    sendGA4Event('add_to_cart', [ga4Item]);
    try {
      await fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      });
      var formData = new FormData();
      formData.append('id', data.variantId);
      formData.append('quantity', '1');
      var response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });
      if (response.ok) {
        sendGA4Event('begin_checkout', [ga4Item]);
        setTimeout(function() {
          window.location.href = '/checkout';
        }, 150);
      } else {
        console.error('Error adding informe to cart:', await response.json());
      }
    } catch (err) {
      console.error('Buy informe error:', err);
    }
  }

  document.querySelectorAll('.informe-cta__buy').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      buyInforme();
    });
  });

  sendGA4Event('view_item', [ga4Item]);
})();
